export default __webpack_public_path__ + "static/media/prototype-review.c305b4d8.jpg";